import React, { useEffect, useState } from "react";

/// React router dom
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import { uuid } from "uuidv4";

/// Css
import "./index.css";
import "./chart.css";
import "./step.css";

/// Layout
import Nav from "./layouts/nav";
import Footer from "./layouts/Footer";

/// Pages
import Registration from "./pages/Registration";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import Error404 from "./pages/Error404";

import Home from "./components/Admin/Home"; ///doctor-details
import AdminList from "./components/Admin/AdminList"; ///doctors
import RoleSummary from "./components/Admin/RoleSummary";
import CreateAccountGuide from "./components/Admin/CreateAccountGuide";
import { ROLE_SUMMARY_HIDDEN_ROLES } from "./components/Admin/RoleSummaryData";

import TechItemList from "./components/Items/TechnicianItems/TechItemList";

import NodeList from "./components/Node/NodeList";

// import BookingSummary from "./components/Booking/BookingSummary"; ///Calendar
import Booking from "./components/Booking/Booking"; ///Calendar
import BookingTable from "./components/Booking/BookingTable"; ///Calendar
import BookingRecovery from "./components/Booking/BookingRecovery";
// import BookingForm from "./components/Booking/BookingForm"; ///jQueryValidationForm

import PatientList from "./components/Patient/PatientList"; /// customer
import PatientPage from "./components/Patient/PatientPage"; ///patient-detail
import PatientRegister from "./components/Patient/PatientRegister"; ///jQueryValidationForm

import TrialCalendar from "./components/CPAP/TrialCalendar"; ///jQueryValidationForm
import CpapTrialRecovery from "./components/CPAP/CpapTrialRecovery";

// import EquipmentList from "./components/Equipment/EquipmentList"; //order
// import EquipmentDetail from "./components/Equipment/EquipmentDetail"; //datatable
// import EquipmentBorrow from "./components/Equipment/EquipmentBorrow"; ///jQueryValidationForm
// import EquipmentRegister from "./components/Equipment/EquipmentRegister"; ///jQueryValidationForm
import { useAuth } from "../context/AuthContext";
import PrivateRoute from "./PrivateRoute";
import PaymentProviderRoute from "./PaymentProviderRoute";
import { TECH_DASHBOARD_VIEW_ROLES } from "./paymentDashboardAccess";

// Form
import Demographic from "./components/Patient/form/DemographicRevC"; //personal information rev.C
import PreSleepInformation from "./components/Patient/form/PreSleepInformation";
import CPAPFollowUp from "./components/Patient/form/CPAPFollowUp";
import SleepHabit from "./components/Patient/form/SleepHabit";
import NightTimeHabit from "./components/Patient/form/NightTimeHabit";
import BerlinQuestionnaire from "./components/Patient/form/BerlinQuestionnaire";
import DaytimeBehavior from "./components/Patient/form/DaytimeBehavior";
import StopbangQuestionnaire from "./components/Patient/form/STOPBANGQuestionnaire";
import PostQuestionnaires from "./components/Patient/form/PostQuestionnaires";
import ShortSAQLI from "./components/Patient/form/ShortSAQLI";
import Followup from "./components/Followup/Calendar";

import CpapRegister from "./components/CPAP/CpapRegister";
import CpapList from "./components/CPAP/CpapList";
import CpapPage from "./components/CPAP/CpapPage";

import BookingList from "./components/Booking/BookingList";
import FollowupList from "./components/Followup/FollowupList";
import ProductList from "./components/Sales/ProductList";
import ProductRegister from "./components/Sales/ProductRegister";
import ProductOrderRegister from "./components/Sales/ProductOrderRegister";
import ProductOrderList from "./components/Sales/ProductOrderList";
import ProductPage from "./components/Sales/ProductPage";
import AccessoriesList from "./components/Sales/Accessories/AccessoriesList";
import TestAccessory from "./components/Sales/Accessories/TestAccessory";
import NewOrderForm from "./components/Sales/Orders/NewOrderForm";
import SaleOrderList from "./components/Sales/Orders/SaleOrderList";
import SalePackageList from "./components/Items/SalePackageItems/SalePackageList";
import ItemList from "./components/Items/ItemList";
import MaskItemList from "./components/Items/MaskItems/MaskItemList";
import CPAPServiceItemList from "./components/Items/CPAPService/CPAPServiceItemList";
import DoctorItemList from "./components/Items/DoctorItems/DoctorItemList";
import ExportPage from "./components/Export/Export";
import SaleItemList from "./components/Items/SaleItems/SaleItemList";
import Backup from "./components/Backup/Backup";
import Dashboard from "./components/Admin/Dashboard";
import TechDashboard from "./components/Admin/TechDashboard";
import DoctorDashboard from "./components/Admin/DoctorDashboard";
import PaymentAccessConfig from "./components/Admin/PaymentAccessConfig";
import RecoveryDeleteAccessConfig from "./components/Admin/RecoveryDeleteAccessConfig";
import AnnualMaskAccessConfig from "./components/Admin/AnnualMaskAccessConfig";
import EmailSenderSettings from "./components/Admin/EmailSenderSettings";
import AccountantItemList from "./components/Items/Accountants/AccItemList";
import ApproverList from "./components/Items/Approvers/ApproverList";
import MaterialIssueList from "./components/Sales/MaterialIssue/MaterialIssueList";
import StockLogsList from "./components/Sales/StockLogs/StockLogsList";
import Setting from "./components/Settings/Settings";
import BookingUrgent from "./components/Booking/BookingUrgent";
import EquipmentList from "./components/Equipments/EquipmentList";
import EquipmentRegister from "./components/Equipments/EquipmentRegister";
import TicketList from "./components/Equipments/TicketList";
import TicketCreate from "./components/Equipments/TicketCreate";
import ServiceTicketCreate from "./components/Service/TicketCreate";
import ServiceTicketList from "./components/Service/TicketList";
import ExternalRepairList from "./components/Service/ExternalRepairList";
import CpapTrialTicketList from "./components/CPAP/Maintenance/CpapTrialTicketList";
import CpapTrialTicketCreate from "./components/CPAP/Maintenance/CpapTrialTicketCreate";
import CpapTrialExternalRepairList from "./components/CPAP/Maintenance/CpapTrialExternalRepairList";
// import Inventory from "./components/Inventory/Inventory";
import TrialInventory from "./components/CPAP/TrialInventory";
import MaskInventory from "./components/CPAP/MaskInventory";
import MaskTransactionList from "./components/CPAP/MaskTransactionList";
import EquipmentPage from "./components/Equipments/EquipmentPage";
import EquipmentDetail from "./components/Equipments/EquipmentDetail";
import Incoming from "./components/Patient/Incoming";
// import TechnicianSchedule from "./components/Booking/TechnicianSchedule";
import TechniciansTable from "./components/Booking/TechniciansTable";
import DoctorSchedule from "./components/Booking/DoctorSchedule";
import { DOCTOR_SCHEDULE_ROLES } from "./components/Booking/doctorScheduleAccess";
import EquipmentOverviewPage from "./components/Items/SleepStudyEquipment/EquipmentOverview";
import SensorStockPage from "./components/Items/SleepStudyEquipment/SensorStock";
import SleepStudyMonitor from "./components/Booking/BookingMonitor";
import SleepStudyMonitorFlowGuide from "./components/Booking/BookingMonitorFlowGuide";
import CPAPFollowupCalendar from "./components/Followup/CPAPFollowupCalendar";
import CPAPFollowupTable from "./components/Followup/CPAPFollowupTable";
import CPAPFollowupDashboard from "./components/Followup/CPAPFollowupDashboard";
import FollowupRecordHistory from "./components/Followup/FollowupRecordHistory";
import AnnualMaskPurchase from "./components/Followup/AnnualMaskPurchase";
import AnnualMaskPurchaseGuide from "./components/Followup/AnnualMaskPurchaseGuide";
import CPAPFollowupGuide from "./components/Followup/CPAPFollowupGuide";
import FeatureRequestList from "./components/Requests/FeatureRequestList";
import PatientPortalTickets from "./components/PatientPortal/PatientPortalTickets";
import PatientPortalComplaints from "./components/PatientPortal/PatientPortalComplaints";
import { COMPLAINT_MANAGEMENT_ROLES } from "./components/PatientPortal/patientPortalComplaintUtils";
import PatientPortalTicketAccessConfig from "./components/Admin/PatientPortalTicketAccessConfig";

const Markup = () => {
  const { currenUser } = useAuth();
  let path = window.location.pathname;
  // console.log("page => ", path);
  path = path.split("/");
  path = path[path.length - 1];
  let pagePath = path.split("-").includes("page");
  // console.log("pagePath => ", pagePath);

  return (
    // <Router basename="/demo/fito/">
    <Router>
      <Switch>
        <Route key={uuid()} exact path={"/page-login"} component={Login} />
        <Route
          key={uuid()}
          exact
          path={"/page-forgot-password"}
          component={ForgotPassword}
        />
        <Route key={uuid()} path="/404" component={Error404} />
        <div
          id={`${!pagePath ? "main-wrapper" : ""}`}
          className={`${!pagePath ? "show" : "mh100vh"}`}
        >
          {!pagePath && <Nav />}
          <div
            className={` ${!pagePath ? "content-body" : ""}`}
            style={{ paddingTop: "0px", marginTop: "3rem" }}
          >
            <div
              className={`${!pagePath ? "container-fluid " : ""}`}
              style={{ minHeight: "720px", "margin-bottom": "80px" }}
            >
              <PrivateRoute
                key={uuid()}
                exact
                path={"/dashboard"}
                component={Dashboard}
              />
              <PaymentProviderRoute
                key={uuid()}
                exact
                path={"/tech-dashboard"}
                component={TechDashboard}
                providerRole="sleep_technician"
                allowedViewRoles={TECH_DASHBOARD_VIEW_ROLES}
              />
              <PaymentProviderRoute
                key={uuid()}
                exact
                path={"/doctor-dashboard"}
                component={DoctorDashboard}
                providerRole="sleep_physician"
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/payment-access-config"}
                component={PaymentAccessConfig}
                allowRoles={[
                  "super_admin",
                  "sleep_technician",
                  "sleep_physician",
                ]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/recovery-delete-access"}
                component={RecoveryDeleteAccessConfig}
                allowRoles={["super_admin"]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/annual-mask-access"}
                component={AnnualMaskAccessConfig}
                allowRoles={["super_admin"]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/email-sender-settings"}
                component={EmailSenderSettings}
                allowRoles={["super_admin"]}
              />
              <PrivateRoute key={uuid()} exact path={"/"} component={Home} />
              <PrivateRoute key={uuid()} exact path={"/patient-portal-tickets"} component={PatientPortalTickets} allowRoles={["super_admin"]} />
              <PrivateRoute key={uuid()} exact path={"/patient-portal-complaints"} component={PatientPortalComplaints} allowRoles={COMPLAINT_MANAGEMENT_ROLES} />
              <PrivateRoute key={uuid()} exact path={"/patient-portal-ticket-access"} component={PatientPortalTicketAccessConfig} allowRoles={["super_admin"]} />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/summarize-role"}
                component={RoleSummary}
                denyRoles={ROLE_SUMMARY_HIDDEN_ROLES}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/create-account-guide"}
                component={CreateAccountGuide}
                allowRoles={["super_admin"]}
              />
              <PrivateRoute
                key={uuid()}
                path={"/admin-list"}
                component={AdminList}
                allowRoles={["super_admin"]}
              />
              <PrivateRoute
                key={uuid()}
                path={"/node-list"}
                component={NodeList}
                disableRoles={[""]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/booking-calendar"}
                component={Booking}
                disableRoles={[""]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/booking-table"}
                component={BookingList}
                disableRoles={[""]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/booking-recovery"}
                component={BookingRecovery}
                allowRoles={["super_admin", "admin"]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/booking-urgent"}
                component={BookingUrgent}
                disableRoles={[""]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/sleep-study-monitor"}
                component={SleepStudyMonitor}
                disableRoles={[""]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/sleep-study-monitor-flow"}
                component={SleepStudyMonitorFlowGuide}
                disableRoles={[""]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/technician-schedule"}
                component={TechniciansTable}
                disableRoles={[""]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/doctor-schedule"}
                component={DoctorSchedule}
                allowRoles={DOCTOR_SCHEDULE_ROLES}
              />

              <PrivateRoute
                key={uuid()}
                exact
                path={"/followup-calendar"}
                component={Followup}
                allowRoles={["super_admin"]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/cpap-followup-dashboard"}
                component={CPAPFollowupDashboard}
                allowRoles={[
                  "super_admin",
                  "admin",
                  "sale",
                  "accountant",
                  "sleep_physician",
                ]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/cpap-followup-calendar"}
                component={CPAPFollowupCalendar}
                allowRoles={[
                  "super_admin",
                  "admin",
                  "staff",
                  "sale",
                  "accountant",
                  "sleep_physician",
                ]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/cpap-followup-table"}
                component={CPAPFollowupTable}
                allowRoles={[
                  "super_admin",
                  "admin",
                  "sale",
                  "accountant",
                  "sleep_physician",
                ]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/annual-mask-purchase"}
                component={AnnualMaskPurchase}
                allowRoles={["super_admin", "admin", "sale", "accountant", "sleep_physician"]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/annual-mask-purchase-guide"}
                component={AnnualMaskPurchaseGuide}
                allowRoles={["super_admin", "admin", "sale", "accountant", "sleep_physician"]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/cpap-followup-guide"}
                component={CPAPFollowupGuide}
                allowRoles={["super_admin", "admin", "staff", "sale", "accountant", "sleep_physician"]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/followup-record-history"}
                component={FollowupRecordHistory}
                allowRoles={[
                  "super_admin",
                  "admin",
                  "sale",
                  "accountant",
                  "sleep_physician",
                ]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/followup-table"}
                component={FollowupList}
                allowRoles={["super_admin"]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/feature-request-list"}
                component={FeatureRequestList}
                allowRoles={[
                  "super_admin",
                  "admin",
                  "sleep_technician",
                  "sale",
                  "accountant",
                ]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/patient-list"}
                component={PatientList}
                disableRoles={[""]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/patient-page/:id"}
                component={PatientPage}
                disableRoles={[""]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/patient-incoming"}
                component={Incoming}
                disableRoles={[""]}
              />
              <PrivateRoute
                key={uuid()}
                path={"/patient-register"}
                component={PatientRegister}
                disableRoles={["staff"]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/demographic/:id/:uuid"}
                component={Demographic}
                disableRoles={[""]}
              />
              <Route
                key={uuid()}
                exact
                path={"/preSleepInformation/:id/:uuid"}
                component={PreSleepInformation}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/cpapFollowUp/:id/:uuid"}
                component={CPAPFollowUp}
                disableRoles={[""]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/sleephabit/:id/:uuid"}
                component={SleepHabit}
                disableRoles={[""]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/nightTimeHabit/:id/:uuid"}
                component={NightTimeHabit}
                disableRoles={[""]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/daytimeBehavior/:id/:uuid"}
                component={DaytimeBehavior}
                disableRoles={[""]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/BerlinQuestionnaire/:id/:uuid"}
                component={BerlinQuestionnaire}
                disableRoles={[""]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/stopbangQuestionnaire/:id/:uuid"}
                component={StopbangQuestionnaire}
                disableRoles={[""]}
              />
              <Route
                key={uuid()}
                exact
                path={"/postQuestionnaires/:id/:uuid"}
                component={PostQuestionnaires}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/shortSAQLI/:id/:uuid"}
                component={ShortSAQLI}
                disableRoles={[""]}
              />

              <PrivateRoute
                key={uuid()}
                exact
                path={"/cpap-register"}
                component={CpapRegister}
                disableRoles={["staff"]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/cpap-page/:id"}
                component={CpapPage}
                disableRoles={["staff"]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/cpap-list"}
                component={CpapList}
                disableRoles={["staff"]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/product-register"}
                component={ProductRegister}
                disableRoles={["staff"]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/product-list"}
                component={ProductList}
                disableRoles={["staff"]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/accessories-list"}
                component={AccessoriesList}
                allowRoles={["super_admin", "sale", "accountant", "admin"]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/test-accessories"}
                component={TestAccessory}
                disableRoles={["staff"]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/new-order"}
                component={NewOrderForm}
                disableRoles={["staff"]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/product-order/:id/:sn/:dn"}
                component={ProductOrderRegister}
                disableRoles={["staff"]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/product-page/:id"}
                component={ProductPage}
                disableRoles={["staff"]}
              />
              {/* ไม่ใช้แล้ว — ใช้ /sale-order-list แทน
              <PrivateRoute
                key={uuid()}
                exact
                path={"/order-list"}
                component={ProductOrderList}
                disableRoles={["staff"]}
              />
              */}
              <PrivateRoute
                key={uuid()}
                exact
                path={"/sale-order-list"}
                component={SaleOrderList}
                disableRoles={["staff"]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/sale-package-list"}
                component={SalePackageList}
                allowRoles={["super_admin", "admin"]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/item-list"}
                component={ItemList}
                disableRoles={["staff"]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/mask-list"}
                component={MaskItemList}
                disableRoles={["staff"]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/cpap-service"}
                component={CPAPServiceItemList}
                disableRoles={["staff"]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/trial-calendar"}
                component={TrialCalendar}
                disableRoles={["staff"]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/cpap-trial-recovery"}
                component={CpapTrialRecovery}
                allowRoles={["super_admin", "admin"]}
              />
              {/* <PrivateRoute
                key={uuid()}
                exact
                path={"/inventory"}
                component={Inventory}
                disableRoles={[""]}
              /> */}
              <PrivateRoute
                key={uuid()}
                exact
                path={"/trial-inventory"}
                component={TrialInventory}
                disableRoles={[""]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/mask-inventory"}
                component={MaskInventory}
                disableRoles={[""]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/mask-transaction"}
                component={MaskTransactionList}
                disableRoles={[""]}
              />
              <PrivateRoute
                key={uuid()}
                path={"/sale-list"}
                component={SaleItemList}
                disableRoles={[""]}
              />

              <PrivateRoute
                key={uuid()}
                path={"/tech-list"}
                component={TechItemList}
                disableRoles={[""]}
              />
              <PrivateRoute
                key={uuid()}
                path={"/doctor-list"}
                component={DoctorItemList}
                disableRoles={[""]}
              />
              <PrivateRoute
                key={uuid()}
                path={"/accountant-list"}
                component={AccountantItemList}
                disableRoles={[""]}
              />
              <PrivateRoute
                key={uuid()}
                path={"/approver-list"}
                component={ApproverList}
                disableRoles={[""]}
              />
              <PrivateRoute
                key={uuid()}
                path={"/material-issue-list"}
                component={MaterialIssueList}
                allowRoles={["super_admin", "sale", "accountant", "admin"]}
              />
              <PrivateRoute
                key={uuid()}
                path={"/stock-logs-list"}
                component={StockLogsList}
                disableRoles={[""]}
              />
              <PrivateRoute
                key={uuid()}
                path={"/export"}
                component={ExportPage}
                disableRoles={[""]}
              />
              <PrivateRoute
                key={uuid()}
                path={"/ticket-list"}
                component={TicketList}
                disableRoles={[""]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/ticket-create"}
                component={TicketCreate}
                disableRoles={[""]}
              />
              <PrivateRoute
                key={uuid()}
                path={"/service-ticket-list"}
                component={ServiceTicketList}
                disableRoles={[""]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/service-ticket-create"}
                component={ServiceTicketCreate}
                disableRoles={[""]}
              />
              <PrivateRoute
                key={uuid()}
                path={"/external-repair-list"}
                component={ExternalRepairList}
                disableRoles={[""]}
              />
              <PrivateRoute
                key={uuid()}
                path={"/cpap-trial-service-list"}
                component={CpapTrialTicketList}
                denyRoles={["staff"]}
              />
              <PrivateRoute
                key={uuid()}
                exact
                path={"/cpap-trial-service-create"}
                component={CpapTrialTicketCreate}
                denyRoles={["staff"]}
              />
              <PrivateRoute
                key={uuid()}
                path={"/cpap-trial-external-repair-list"}
                component={CpapTrialExternalRepairList}
                denyRoles={["staff"]}
              />
              <PrivateRoute
                key={uuid()}
                path={"/equipment-list"}
                component={EquipmentList}
                disableRoles={[""]}
              />
              <PrivateRoute
                key={uuid()}
                path={"/sleep-study-sensor"}
                component={SensorStockPage}
                disableRoles={[""]}
              />
              <PrivateRoute
                key={uuid()}
                path={"/sleep-study-equipment"}
                component={EquipmentOverviewPage}
                disableRoles={[""]}
              />
              <PrivateRoute
                key={uuid()}
                path={"/equipment-page/:id"}
                component={EquipmentPage}
                disableRoles={[""]}
              />
              <PrivateRoute
                key={uuid()}
                path={"/equipment-register"}
                component={EquipmentRegister}
                disableRoles={[""]}
              />
              <PrivateRoute
                key={uuid()}
                path={"/backup"}
                component={Backup}
                disableRoles={[""]}
              />
              <PrivateRoute
                key={uuid()}
                path={"/settings"}
                component={Setting}
                disableRoles={[""]}
              />
            </div>
          </div>
          {!pagePath && <Footer />}
        </div>
      </Switch>
      {/* <Setting /> */}
    </Router>
  );
};

export default Markup;
